export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11423.5f6f2a65.jpg";